import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { goBack } from '@app/helpers/routingHelper'
import classnames from 'classnames'
import SVG from 'react-inlinesvg'
import icon from '@icons/arrow/left'

const BackLink = ({
  children,
  to,
  className,
  history,
  location: _location,
  staticContext: _staticContext,
  match: _match,
  ...props
}) => {

  const classes = classnames(
    'link', 'back-link', 'f--upper', className
  );

  const content = <>
    <SVG src={icon} />
    { children || I18n.t("common.back") }
  </>

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {content}
      </Link>
    )
  }

  return (
    <span onClick={() => {
        goBack(history)
      }
    } className={classes} {...props}>
      {content}
    </span>
  )
}

export default withRouter(BackLink)
